module.exports = __webpack_public_path__ + "static/media/Sky.fdc5d10b.png";